import { Global, css } from '@emotion/core';
import { ITheme } from '../../themer';
import { Responsive } from '../../utils';

interface IProps {
	theme: ITheme;
}

export function Typography({ theme }: IProps) {
	const { body, header, paragraph, link, small, mobile } = theme.typography;

	const styles = css`
		body {
			font-family: ${body.fontFamily};
			font-size: ${body.size};
			line-height: ${body.lineHeight};
			color: ${body.color};
			font-weight: ${body.fontWeight};
		}

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			margin: ${header.margin};
			padding: 0;
			line-height: ${header.lineHeight};
		}

		h1 {
			font-size: ${header.h1.size};
			color: ${header.h1.color};
			font-weight: ${header.h1.fontWeight};
			font-family: ${header.h1.fontFamily};
		}

		h2 {
			font-size: ${header.h2.size};
			color: ${header.h2.color};
			font-weight: ${header.h2.fontWeight};
			font-family: ${header.h2.fontFamily};
		}

		h3 {
			font-size: ${header.h3.size};
			color: ${header.h3.color};
			font-weight: ${header.h3.fontWeight};
			font-family: ${header.h3.fontFamily};
		}

		h4 {
			font-size: ${header.h4.size};
			color: ${header.h4.color};
			font-weight: ${header.h4.fontWeight};
			font-family: ${header.h4.fontFamily};
		}

		h5 {
			font-size: ${header.h5.size};
			color: ${header.h5.color};
			font-weight: ${header.h5.fontWeight};
			font-family: ${header.h5.fontFamily};
		}

		h6 {
			font-size: ${header.h6.size};
			color: ${header.h6.color};
			font-weight: ${header.h6.fontWeight};
			font-family: ${header.h6.fontFamily};
		}

		p {
			margin: ${paragraph.margin};
		}

		a {
			color: ${link.color};
			text-decoration: ${link.textDecoration};
			font-weight: ${link.fontWeight};

			&:hover {
				color: ${link.hover.color};
				text-decoration: ${link.hover.textDecoration};
			}

			&:active {
				color: ${link.active.color};
			}
		}

		small {
			font-size: ${small.size};
			color: ${small.color};
			font-weight: ${small.weight};
		}

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			body {
				font-size: ${mobile.body.size};
				line-height: ${mobile.body.lineHeight};
			}

			h1,
			h2,
			h3,
			h4,
			h5,
			h6 {
				margin: ${mobile.header.margin};
				line-height: ${mobile.header.lineHeight};
			}

			h1 {
				font-size: ${mobile.header.h1.size};
			}

			h2 {
				font-size: ${mobile.header.h2.size};
			}

			h3 {
				font-size: ${mobile.header.h3.size};
			}

			h4 {
				font-size: ${mobile.header.h4.size};
			}

			h5 {
				font-size: ${mobile.header.h5.size};
			}

			h6 {
				font-size: ${mobile.header.h6.size};
			}

			p {
				margin: ${mobile.paragraph.margin};
			}

			small {
				font-size: ${mobile.small.size};
			}
		}
	`;

	return <Global styles={styles} />;
}
